import { observer } from 'mobx-react';
import * as React from 'react';
import { TimeZone } from '../../ProfileStore/Types';
import { T } from '../../Translations';
import { useTranslationsContext } from '../../Translations/UseTranslationsContext';

interface Props {
  value: string;
  onChange: (timeZone: string) => void;
  options: ReadonlyArray<TimeZone>;
  disabled?: boolean;
}

function TimeZoneField({ value, onChange, options, disabled }: Props) {
  const { translate } = useTranslationsContext();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className="flex flex-col sm:w-full">
      <label
        htmlFor="time-zone-field-select"
        className="mb-1 text-xs font-medium uppercase tracking-wider text-zinc-700"
      >
        <T kind="Time Zone" />
      </label>
      <div className="relative">
        <select
          id="time-zone-field-select"
          value={value}
          onChange={handleChange}
          disabled={disabled}
          aria-required={true}
          className="w-full appearance-none rounded border border-zinc-300 bg-white py-2 pl-3 pr-10 text-sm text-zinc-900 focus:outline-none focus:ring-2 disabled:border-zinc-200 disabled:bg-zinc-200"
          data-testid="time-zone-field_select"
          data-intercom-target="time-zone-select"
        >
          <option value="">{translate('Select a time zone')}</option>
          {options.map((tz) => (
            <option key={tz.name} value={tz.name}>
              {tz.fullName}
            </option>
          ))}
        </select>
        <span
          className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-zinc-500"
          aria-hidden="true"
        >
          <svg
            className="h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
              clipRule="evenodd"
            />
          </svg>
        </span>
      </div>
    </div>
  );
}

export default observer(TimeZoneField);
